export const FEEDBACKS_ESTIMATE = {
    POSITIVE_SMILE: 1,
    NEGATIVE_SMILE: 0,
} as const;

export const FEEDBACKS_CUSTOMER_STATUS = {
    AFTER_SMILE_PAGE: 2,
    AFTER_WISHES_PAGE: 3,
    AFTER_CONTACT_PAGE: 4,
} as const;

export const COMPANY_IDS_FOR_FEEDBACKS = [15, 12, 129, 134, 98, 1283];

export const FEEDBACK_SRC = {
    SERVICE: 0,
    PAYMENT: 1,
} as const;

export const DISABLE_OR_ENABLE_BUTTON = [
    { background: 'linear-gradient(270deg, #5c81ed 5.76%, #b984fa 92.6%)' },
    { background: '#808080b8' },
] as const;

export const FEEDBACK_PAGES = {
    smile: 'smilepage',
    checkbox: 'checkboxpage',
    wishes: 'wishespage',
    contact: 'contactpage',
    complete: 'completepage',
} as const;

export const FEEDBACK_ROUTES = {
    smile: `/:id/${FEEDBACK_PAGES.smile}`,
    checkbox: `/:id/${FEEDBACK_PAGES.checkbox}`,
    wishes: `/:id/${FEEDBACK_PAGES.wishes}`,
    contact: `/:id/${FEEDBACK_PAGES.contact}`,
    complete: `/:id/${FEEDBACK_PAGES.complete}`,
} as const;

export const FEEDBACK_API = {
    UPDATE_FEEDBACKS: '/api/post_feedbacks_data',
    CREATE_TELEMETRY_EVENT: '/api/create_telemetry_event',
    UPDATE_TELEMETRY_EVENT: '/api/update_telemetry_event',
} as const;
